import React from 'react';
import Header from './Header';


const Layout = ({ children }) => (
  <div className="main-wrapper">
    <Header />
    {children}
  </div>
);

export default Layout;
